import { NextStudioLayout, NextStudioNoScript } from "./_chunks-es/NextStudioNoScript.js";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { NextStudio } from "next-sanity/studio/client-component";
import { preloadModule } from "react-dom";
const viewport = {
  width: "device-width",
  initialScale: 1,
  // Studio implements display cutouts CSS (The iPhone Notch ™ ) and needs `viewport-fit=covered` for it to work correctly
  viewportFit: "cover"
}, metadata = {
  referrer: "same-origin",
  robots: "noindex"
}, bridgeScript = "https://core.sanity-cdn.com/bridge.js";
function NextStudioWithBridge(props) {
  return preloadModule(bridgeScript, { as: "script" }), /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("script", { src: bridgeScript, async: !0, type: "module", "data-sanity-core": !0 }),
    /* @__PURE__ */ jsx(NextStudio, { ...props })
  ] });
}
export {
  NextStudioWithBridge as NextStudio,
  NextStudioLayout,
  NextStudioNoScript,
  metadata,
  viewport
};
//# sourceMappingURL=studio.js.map
